import { render } from "./JobsApproval.vue?vue&type=template&id=4e10027d"
import script from "./JobsApproval.vue?vue&type=script&lang=js"
export * from "./JobsApproval.vue?vue&type=script&lang=js"

import "./JobsApproval.vue?vue&type=style&index=0&id=4e10027d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__